"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jQuery = require("jquery");
function frameForSrc(src) {
    const frame = jQuery('<iframe>')
        .attr('src', src)
        .attr('width', '100%')
        .attr('height', '100%')
        .attr('id', 'stronghold-pay-iframe')
        .css('position', 'fixed')
        .css('top', '0px')
        .css('right', '0px')
        .css('bottom', '0px')
        .css('left', '0px')
        .css('z-index', '2147483647')
        .css('border', 'none')
        .css('display', 'block')
        .css('overflow', 'hidden auto');
    jQuery('body').append(frame);
    return frame;
}
exports.frameForSrc = frameForSrc;
function getOptionQuery(options) {
    const query = {};
    query.payLinkCode = options.payLinkCode;
    return query;
}
exports.getOptionQuery = getOptionQuery;
function getChargeQuery(charge) {
    const query = {};
    if (!charge)
        return query;
    query.chargeAmount = charge.amount;
    query.chargePaymentSourceId = charge.paymentSourceId;
    query.paymentSourceId = charge.paymentSourceId;
    query.chargeExternalId = charge.externalId;
    return query;
}
exports.getChargeQuery = getChargeQuery;
function getTipQuery(tip) {
    const query = {};
    if (!tip)
        return query;
    query.tipAmount = tip.amount;
    query.tipBeneficiaryName = tip.beneficiaryName;
    query.tipPaymentSourceId = tip.paymentSourceId;
    query.paymentSourceId = tip.paymentSourceId;
    query.tipChargeId = tip.chargeId;
    if (tip.details) {
        query.tipDetailsDisplayMessage = tip.details.displayMessage;
        query.tipDetailsTerminalId = tip.details.terminalId;
        query.tipDetailsDrawerId = tip.details.drawerId;
    }
    return query;
}
exports.getTipQuery = getTipQuery;
//# sourceMappingURL=utils.js.map